import React from 'react';
import { Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import { Check } from 'lucide-react';
const Scheduled = () => {
  return <article data-sentry-component="Scheduled" data-sentry-source-file="Scheduled.tsx">
      <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="Scheduled.tsx">
        Interview
      </Typography>
      <div className="relative p-5 border-2 border-[#F7E0B4] bg-[#FEFBE8] rounded-lg flex gap-2 text-center items-center my-6">
        <div className="flex flex-col items-center self-center gap-2 mx-auto text-center">
          <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/5efc5de6-1603-43d7-a544-a44a4e555d68.svg" alt="scheduled" width={40} height={40} data-sentry-element="Image" data-sentry-source-file="Scheduled.tsx" />
          <div className="flex items-center gap-2">
            <Typography variant="heading3" weight="semi-bold" className="!text-sm sm:!text-lg" data-sentry-element="Typography" data-sentry-source-file="Scheduled.tsx">
              Interview Scheduled
            </Typography>
            <Check size={20} color="#3D3D3D" data-sentry-element="Check" data-sentry-source-file="Scheduled.tsx" />
          </div>
          <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Scheduled.tsx">
            Your interview is scheduled successfully!
          </Typography>
          <Typography variant="regular" className="!text-sm !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="Scheduled.tsx">
            We’ve shared the interview{' '}
            <span className="font-semibold">joining details via email</span>. Please make sure to
            join on time.
          </Typography>
        </div>
      </div>
    </article>;
};
export default Scheduled;